import { render } from "./QuotesView.vue?vue&type=template&id=5f6a80a8&scoped=true"
import script from "./QuotesView.vue?vue&type=script&lang=js"
export * from "./QuotesView.vue?vue&type=script&lang=js"

import "./QuotesView.vue?vue&type=style&index=0&id=5f6a80a8&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6a80a8"]])

export default __exports__